module.exports = __webpack_public_path__ + "static/Stock_List-7ef6478808e01e66b02af3d5f9cc431f.pdf";